import { object, string } from 'yup';

export default object().shape({
  templateSelection: string().required(() => 'Required'),
});
